import { render, staticRenderFns } from "./PlayAvatarGroup.vue?vue&type=template&id=6087ccb0&scoped=true"
import script from "./PlayAvatarGroup.vue?vue&type=script&lang=js"
export * from "./PlayAvatarGroup.vue?vue&type=script&lang=js"
import style0 from "./PlayAvatarGroup.vue?vue&type=style&index=0&id=6087ccb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087ccb0",
  null
  
)

export default component.exports